<div class="drawer-header border-bottom">
    <span class="title">Perfil do usuário</span>
    <p-button (onClick)="closeModal()" icon="pi pi-times" [rounded]="true" [text]="true" severity="secondary" />
</div>
<div class="content-drawer">
    
    <div class="basic-info">
        <div class="avatar">
            <p-avatar
                *ngIf="!imageError && perfilDetail?.foto; else defaultAvatar"
                [image]="perfilDetail?.foto"
                shape="circle"
                size="xlarge"
                (onImageError)="imageError = true"
            />
            <ng-template #defaultAvatar>
                <p-avatar
                    [label]="getInitials(perfilDetail?.nome)"
                    [icon]="!perfilDetail?.nome ? 'pi pi-user' : undefined"
                    shape="circle"
                    size="xlarge"
                />
            </ng-template>
        </div>
        <div class="details">
            <h3 class="name">Nome: {{perfilDetail?.nome}} </h3>
            <p class="description">NIF:  </p>
        </div>
    </div>

    <div class="d-flex justify-content-between gap-3 mt-4">
        <div class="card-info w-50">
          <div class="icon">
            <i class="pi pi-envelope"></i>
          </div>
          <div class="description">
            <span class="title">Email</span>
            <span class="info">  </span>
            <!-- <span class="info">{{ candidatura()?.estadoCandidatura | estadoCandidaturaDesc }}</span> -->
          </div>
        </div>
        <div class="card-info w-50">
          <div class="icon">
            <i class="pi pi-phone"></i>
          </div>
          <div class="description">
            <span class="title">Telefone</span>
            <span class="info mt-2"><strong>  </strong></span>
          </div>
        </div>
    </div>
    <div class="endereco">
        <div class="icon">
            <i class="pi pi-map-marker"></i>
        </div>
        <div class="description">
            <span class="info mt-2"><strong>  </strong></span>
            <!--pi-map-marker <span class="info">{{ candidatura()?.estadoCandidatura | estadoCandidaturaDesc }}</span> -->
        </div>
    </div>


    <!-- 
    <div class="about mt-4">
        <span class="title">Sobre o profissional</span>
        <p>{{ profissional()?.sobreMim }}</p>
    </div>

    <div class="about mt-4">
        <span class="title">Formação acadêmica</span>
        @for (item of listaHabilitacoes; track $index) {
        <div class="education-card mt-3">
            <div class="graduation-icon">
                <-- <img src="icons/graduation-grey.svg" alt=""> --
            </div>
            <div class="info">
                <span class="course">{{item.designacao}}</span>
                <span class="institution">{{item.instituicao}}</span>
                <span class="period">{{item.dataInicio | date:'dd-MM-yyyy'}} - {{item.dataFim |
                    date:'dd-MM-yyyy'}}</span>
            </div>
        </div>
        }
    </div>

    <div class="about mt-4">
        <span class="title">Histórico profissional</span>
        @for (item of listaExperiencias; track $index) {
        <div class="education-card mt-3">
            <div class="graduation-icon">
                <-- <img src="icons/graduation-grey.svg" alt=""> --
            </div>
            <div class="info">
                <span class="course">{{item.designacaoFuncao}}</span>
                <span class="institution">{{item.nomeEmpresa}}</span>
                <span class="period">
                    {{item.dataInicio | date:'dd-MM-yyyy'}} - {{item.isActualEmprego ? "até ao momento." :
                    (item.dataFim | date:'dd-MM-yyyy')}}
                </span>
                <-- <p>
                    {{item.descricao}}
                </p> --
            </div>
        </div>
        }
    </div>

    <div class="about mt-4">
        <span class="title">Competências</span>
        <div class="d-flex flex-wrap gap-2 align-items-center">
            @for (item of listaCompetencias; track $index) {
            <div class="comp-chip">
                <span class="label"> {{item.designacao}}</span>
            </div>
            }
        </div>
    </div>

    <div class="about mt-4">
        <span class="title">Línguas</span>
        <div class="card-content pt-3">
            <p-table [value]="listaLinguas" stripedRows [tableStyle]="{ 'width': '100%' }">
                <ng-template #header>
                    <tr>
                        <th>Idioma</th>
                        <th>Redação</th>
                        <th>Fala</th>
                        <th>Compreensão de Leitura</th>
                    </tr>
                </ng-template>
                <ng-template #body let-lingua>
                    <tr>
                        <td>{{lingua.lingua.designacao}}</td>
                        <td>{{getNivelByEnum(lingua.redacao)}}</td>
                        <td>{{getNivelByEnum(lingua.fala)}}</td>
                        <td>{{getNivelByEnum(lingua.leitura)}}</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>-->
    
</div>